import { EQUIPMENT_DETAILS_FORM_VALUES } from 'texts/equipmentDetails'

export const minMaxPriceValidation = (
  _value: string | number,
  values: Record<string, unknown>
) => {
  if (
    values.price &&
    values.maxAmount &&
    Number(values.price) > Number(values.maxAmount)
  ) {
    return {
      message: EQUIPMENT_DETAILS_FORM_VALUES.MAX_AMOUNT.VALIDATION_MESSAGE,
    }
  }
  return false
}
